<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ detail__detail? 'DÉTAIL DU' : (Object.entries(this.data).length === 0 ? "NOUVEAU" : "MODIFIER UN") }} TYPE</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"/>
        </div>
        <vs-divider class="mb-0" />
        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
            <div class="px-6 py-2">
                <p class="mt-5" >Nom du type <b style="color: #ff6141">*</b> </p>
                <vs-input
                    :disabled="detail__detail"
                    :danger="error_data.name ? true : false"
                    :danger-text="error_data.name ? error_data.name[0] : ''"
                     v-model="input.name" class="w-full" name="item-code" />

                <p class="mt-5" >Catégorie <b style="color: #ff6141">*</b> </p>
                <v-select :disabled="detail__detail" :reduce="rep => rep.id" class="w-full" label="name" v-model="input.requests_type_id" :options="categories"></v-select>
                <span style="text-align: center !important;" v-if="error_data.requests_type_id" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    {{ error_data.requests_type_id ? error_data.requests_type_id[0] : ''}}
                </span>

                <vs-input-number min="1" :disabled="detail__detail" v-model="input.sla_very_high" label="SLA Priorité Très Élevée (en min) :" class="mt-5 w-full" />
                <span style="text-align: center !important;" v-if="error_data.sla_very_high" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    {{ error_data.sla_very_high ? error_data.sla_very_high[0] : ''}}
                </span>
                <vs-input-number min="1" :disabled="detail__detail" v-model="input.sla_high" label="SLA Priorité Élevée (en min) :" class="mt-5 w-full" />
                <span style="text-align: center !important;" v-if="error_data.sla_high" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    {{ error_data.sla_high ? error_data.sla_high[0] : ''}}
                </span>

                <vs-input-number min="1" :disabled="detail__detail" v-model="input.sla_average" label="SLA Priorité Moyenne (en min) :" class="mt-5 w-full" />
                <span style="text-align: center !important;" v-if="error_data.sla_average" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    {{ error_data.sla_average ? error_data.sla_average[0] : ''}}
                </span>

                <vs-input-number min="1" :disabled="detail__detail" v-model="input.sla_low" label="SLA Priorité Basse (en min) :" class="mt-5 w-full" />
                <span style="text-align: center !important;" v-if="error_data.sla_low" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    {{ error_data.sla_low ? error_data.sla_low[0] : ''}}
                </span>

                <div class="mt-5 w-full">
                    <vs-checkbox :disabled="detail__detail" v-model="dataMustBeApprove">Soumis à approbation</vs-checkbox>
                </div>

                <p class="mt-5" v-if="dataMustBeApprove" >Chaine d'approbation <b style="color: #ff6141">*</b> </p>
                <v-select :disabled="detail__detail" v-if="dataMustBeApprove" :reduce="rep => rep.id" class="w-full" label="chain" v-model="input.chain_id" :options="approvalChanel"></v-select>
                <span style="text-align: center !important;" v-if="error_data.chain_id" class="span-text-validation con-text-validation span-text-validation-danger vs-input--text-validation-span">
                    {{ error_data.chain_id ? error_data.chain_id[0] : ''}}
                </span>

                <vs-textarea :disabled="detail__detail" label="Description" v-model="input.description" class="mt-5 w-full" />

            </div>
        </VuePerfectScrollbar>
        <div v-if="!detail__detail" class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="mr-6" @click="submitData">Soumettre</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false, initValues(), dataMustBeApprove = false">Annuler</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    var base_self;
    var input_tempon = {
        id: null,
        requests_type_id: '',
        name: '',
        sla_average: 1,
        sla_very_high: 1,
        sla_high: 1,
        sla_low: 1,
        chain_id: '',
        description: ''
    };

    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        components: {VuePerfectScrollbar},
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            data: {
                type: Object,
                default: () => {},
            },
            edit: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
              error_data: [],
                detail__detail: false,
                error: {
                    requests_type_id: false,
                    name: false,
                    sla_average: false,
                    sla_high: false,
                    sla_low: false,
                    chain_id: false
                },
                input: {},
                dataMustBeApprove: false,
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },

                categories: [],

                approvalChanel: [],
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if(!val) {
                        this.$emit('closeSidebar')
                    }
                }
            },
        },
        methods: {
            async chains () {
                let response = await base_self.$store.state.chains({}, { paginate: 0, page: ''  });
                base_self.approvalChanel = response.data.data;
            },
            async categories_requests () {
                let response = await base_self.$store.state.categories_requests({}, { paginate: 0  });
                base_self.categories = response.data;
            },
            async submitData() {
                var input = JSON.parse(JSON.stringify(this.input));
                input.has_approbation = this.dataMustBeApprove
                if(!this.edit) {
                    this.$vs.loading()
                    this.$http.post('/sub-requests/create', input).then((response) =>{
                      this.$vs.loading.close()
                      if (response.data.status) {
                        window.GETCCMT.success('Le type de demande est crée avec succès.', response);
                        window.TypesApp.getSub_requests(window.TypesApp.page);
                        this.$emit('closeSidebar');
                        this.initValues()
                      } else {
                        window.GETCCMT.error({ message: 'La création du type de demande a échouée.' });
                      }
                    }).catch((error) => {
                      this.$vs.loading.close()
                      if (error.response.status === 401){
                        window.GETCCMT.$router.push('/login')
                      }else {
                        this.error_data = error.response.data.errors
                      }
                    })
                } else {
                  input.has_approbation = this.dataMustBeApprove
                  this.$vs.loading()
                  this.$http.post('/sub-requests/update', input).then((response) =>{
                    if (response.data.status) {
                      window.GETCCMT.success('Le type de demande est modifiée avec succès.', response);
                      console.log('response: ', response);
                      window.TypesApp.getSub_requests(window.TypesApp.page);
                      this.$emit('closeSidebar');
                      this.initValues()
                    } else {
                      window.GETCCMT.error({ message: 'La modification du type de demande a échouée.' });
                    }
                  }).catch((error) => {
                    this.$vs.loading.close()
                    if (error.response.status === 401){
                      window.GETCCMT.$router.push('/login')
                    }else {
                      this.error_data = error.response.data.errors
                    }
                  })
                }
            },
            initValues() {
                this.input = JSON.parse(JSON.stringify(input_tempon));
                this.detail__detail = false;
            }
        },
        watch: {
            async isSidebarActive() {
                this.error_data = []
                if(window.TypesApp.sidebarData.id) {
                    let response = await base_self.$store.state.sub_requests_detail({}, window.TypesApp.sidebarData.id);
                    this.input = JSON.parse(JSON.stringify(response.data));
                    this.dataMustBeApprove = this.input.has_approbation;
                    this.detail__detail = window.TypesApp.detail__detail;
                } else {
                    this.initValues()
                }
            }
        },
        created() {
            window.EditType = this;
            base_self = this;
            base_self.initValues()
            console.log(this.input)
            base_self.categories_requests()
            base_self.chains()

        }

    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
        height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
    }
    .vs-input-number {
        justify-content: space-around;
    }
</style>
